<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Completadas</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay transacciones que coincidan con la búsqueda"
                    empty-text="No hay transacciones para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button variant="primary" size="sm" @click="getViewer(row.item.id)" :disabled="!row.item.voucher" v-b-modal.voucher>
                            <i class="material-icons">photo</i>
                        </b-button>
                        <b-button class="text-white" variant="info" size="sm" :to="'/admin/request/' + row.item.id + '/details'">
                            <i class="material-icons">info</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Voucher Viewer -->
                <b-modal
                    id="voucher"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="'ID: '+id"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <img :src="'/'+voucher" :title="id" alt="Voucher" width="100%"/>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Completed",
    props: [ 'user' ],
    data: () => ({
        id: 0,
        voucher: '',
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'int_id', label: 'Código', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'customer', label: 'Corresponsal', sortable: false },
            { key: 'fee_text', label: 'Comisión', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'amount_send_text', label: 'Valor Origen', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'currency_send', label: 'Moneda Origen', sortable: false },
            { key: 'fx_rate', label: 'Conversión', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'amount_receiver_text', label: 'Valor Destino', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'currency_receiver', label: 'Moneda Destino', sortable: false },
            { key: 'date', label: 'Fecha', sortable: false },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'completedpage');
        this.totalRows = this.items.length;
        this.getIni();
    },
    methods: {
        getIni() {
            axios.get('/api/paymaster/completed').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getViewer(id) {
            this.id = id;
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    this.voucher = items[i].voucher;
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
